import { render, staticRenderFns } from "./EmployeeTable.vue?vue&type=template&id=ebdf6df6&scoped=true"
import script from "./EmployeeTable.vue?vue&type=script&lang=js"
export * from "./EmployeeTable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeTable.vue?vue&type=style&index=0&id=ebdf6df6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebdf6df6",
  null
  
)

export default component.exports